import { useState, useContext } from "react";
import { Container,  Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import AppContext from "../../../context/AppContext";
import "../../../assets/css/Customer/CustomerDashboard/CustomerRating.css";
import "../../../assets/css/Customer/CustomerDashboard/CustomerInstantRide.css";
import BottomNav from "../../../components/Customer/general/BottomNav";

export default function CustomerRating() {
  const { baseUrl, authToken } = useContext(AppContext);
  const location = useLocation();
  const navigate = useNavigate();

  // ride_id aur driver_id pichli screen se aayenge
  const { tdride_id, tddriver_id} = location.state || {};

  const [rating, setRating] = useState(0);
  const [hovered, setHovered] = useState(0);
  const [selectedTags, setSelectedTags] = useState([]);
  const [comment, setComment] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const tags = [
    "Punctual",
    "Safe Driver",
    "Friendly",
    "Clean Car",
    "Professional",
    "Great Music",
  ];

  const toggleTag = (tag) => {
    setSelectedTags((prev) =>
      prev.includes(tag) ? prev.filter((t) => t !== tag) : [...prev, tag],
    );
  };

  const getRatingLabel = (r) => {
    const labels = [
      "",
      "Terrible 😞",
      "Bad 😕",
      "Okay 😐",
      "Good 😊",
      "Excellent 🤩",
    ];
    return labels[r] || "";
  };

  // axios call//
  const handleSubmit = () => {
    if (rating === 0) return;
    setLoading(true);

    // form data calling//
    const formData = new FormData();
    formData.append("tdride_id", tdride_id);
    formData.append("tddriver_id", tddriver_id);
   
     formData.append("rate_star", rating);
    formData.append("comment", comment);

    // axios//
    axios
      .post(`${baseUrl}/customer/rating/createRating`, formData, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        setLoading(false);
        console.log(response.data);
        if (response.data.success === true) {
          setSubmitted(true);
        } else {
          alert("Rating submission failed. Please try again.");
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        alert("Network Error! Please try again.");
      });
  };

  if (submitted) {
    return (
      <div className="customerrating-wrapper">
        <Container className="customerrating-container d-flex align-items-center justify-content-center">
          <div className="customerrating-thankyou text-center">
            <div className="customerrating-checkmark">✓</div>
            <h2 className="customerrating-thankyou-title">Thank You!</h2>
            <p className="customerrating-thankyou-sub">
              Your feedback helps us improve Trustidrive
            </p>
            <Button
              className="customerrating-done-btn"
              onClick={() => navigate("/customer-dashboard")}
            >
              Back to Home
            </Button>
          </div>
        </Container>
      </div>
    );
  }

  return (
    <div className="customerrating-wrapper">
      <Container className="customerrating-container">
        {/* Header */}
        <div className="customerrating-header text-center">
          <div className="customerrating-logo">Trustidrive</div>
          <p className="customerrating-header-sub">Rate your experience</p>
        </div>

        {/* Ride Summary Card */}
        
                

        {/* Star Rating */}
        <div className="customerrating-stars-section text-center">
          <p className="customerrating-stars-label">How was your ride?</p>
          <div className="customerrating-stars">
            {[1, 2, 3, 4, 5].map((star) => (
              <span
                key={star}
                className={`customerrating-star ${
                  star <= (hovered || rating)
                    ? "customerrating-star--active"
                    : ""
                }`}
                onMouseEnter={() => setHovered(star)}
                onMouseLeave={() => setHovered(0)}
                onClick={() => setRating(star)}
              >
                ★
              </span>
            ))}
          </div>
          <p className="customerrating-rating-label">
            {getRatingLabel(hovered || rating)}
          </p>
        </div>

        {/* Quick Tags */}
        <div className="customerrating-tags-section">
          <p className="customerrating-tags-title">What went well?</p>
          <div className="customerrating-tags-wrap">
            {tags.map((tag) => (
              <button
                key={tag}
                className={`customerrating-tag-btn ${
                  selectedTags.includes(tag)
                    ? "customerrating-tag-btn--selected"
                    : ""
                }`}
                onClick={() => toggleTag(tag)}
              >
                {tag}
              </button>
            ))}
          </div>
        </div>

        {/* Comment Box */}
        <div className="customerrating-comment-section">
          <p className="customerrating-comment-label">
            Add a comment (optional)
          </p>
          <textarea
            className="customerrating-textarea"
            placeholder="Tell us more about your experience..."
            rows={3}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
        </div>

        {/* Submit Button */}
        <div className="customerrating-submit-wrap">
          <Button
            className="customerrating-submit-btn"
            onClick={handleSubmit}
            disabled={rating === 0 || loading}
          >
            {loading ? "Submitting..." : "Submit Rating"}
          </Button>
        </div>
      </Container>
      <BottomNav />
    </div>
  );
}
